// Demo dataset used when the app is running as a local-dev user (`LOCAL_DEV_ORG_ID`).
// Bypasses Firestore queries so the UI can be previewed without credentials or data.
// All numbers are illustrative, not real customer data.

export const LOCAL_DEV_ORG_ID = 'local-dev-org';

export const dashboardDemoData = {
  financials: {
    totalRevenue: 184320,
    lastMonthRevenue: 161870,
    totalBills: 96540,
    lastMonthBills: 102250,
  },
  aging: {
    receivables: 42180,
    payables: 28640,
    pendingInvoicesList: [
      { id: 'inv-1', contactName: 'Nile Trading Co.',    createdAt: { toDate: () => new Date(Date.now() - 5 * 86400000) },  dueDate: { toDate: () => new Date(Date.now() + 9 * 86400000) },  amount: 12450 },
      { id: 'inv-2', contactName: 'Cedar Logistics',      createdAt: { toDate: () => new Date(Date.now() - 11 * 86400000) }, dueDate: { toDate: () => new Date(Date.now() + 4 * 86400000) },  amount: 8320 },
      { id: 'inv-3', contactName: 'Acme Hardware LLC',    createdAt: { toDate: () => new Date(Date.now() - 18 * 86400000) }, dueDate: { toDate: () => new Date(Date.now() - 1 * 86400000) },  amount: 21410 },
    ],
    pendingBillsList: [
      { id: 'bill-1', supplierName: 'Global Supply Ltd.', createdAt: { toDate: () => new Date(Date.now() - 3 * 86400000) },  dueDate: { toDate: () => new Date(Date.now() + 12 * 86400000) }, amount: 14200 },
      { id: 'bill-2', supplierName: 'BrightPack Printing', createdAt: { toDate: () => new Date(Date.now() - 14 * 86400000) }, dueDate: { toDate: () => new Date(Date.now() + 2 * 86400000) },  amount: 4440 },
    ],
  },
  operations: {
    activeSessions: 42,
    tasks: { Pending: 7, 'In Progress': 4, Completed: 33 },
    alerts: [
      { id: 'al-1', type: 'critical', title: 'Overdue Invoice',     message: 'Acme Hardware LLC invoice past due by 1 day', },
      { id: 'al-2', type: 'warning',  title: 'Cash Flow Tightening', message: 'Outbound payments exceed inbound receipts this week', },
      { id: 'al-3', type: 'healthy',  title: 'Reconciliation Clean',  message: 'All bank accounts reconciled for current period', },
    ],
    recentContacts: [
      { id: 'c-1', name: 'Nile Trading Co.', type: 'Customer', time: '2h ago' },
      { id: 'c-2', name: 'Cedar Logistics',   type: 'Supplier', time: '5h ago' },
      { id: 'c-3', name: 'Acme Hardware LLC', type: 'Customer', time: '1d ago' },
      { id: 'c-4', name: 'BrightPack Printing', type: 'Supplier', time: '2d ago' },
      { id: 'c-5', name: 'Global Supply Ltd.', type: 'Supplier', time: '4d ago' },
    ],
  },
  analytics: {
    plData: [
      { name: 'Jan', revenue: 84000,  expenses: 61000 },
      { name: 'Feb', revenue: 102000, expenses: 73000 },
      { name: 'Mar', revenue: 118000, expenses: 81000 },
      { name: 'Apr', revenue: 96000,  expenses: 78000 },
      { name: 'May', revenue: 142000, expenses: 89000 },
      { name: 'Jun', revenue: 161870, expenses: 102250 },
      { name: 'Jul', revenue: 184320, expenses: 96540 },
    ],
    cashFlowData: [
      { name: 'Jan', inbound: 78000,  outbound: 64000, net: 14000 },
      { name: 'Feb', inbound: 95000,  outbound: 71000, net: 24000 },
      { name: 'Mar', inbound: 112000, outbound: 88000, net: 24000 },
      { name: 'Apr', inbound: 89000,  outbound: 76000, net: 13000 },
      { name: 'May', inbound: 138000, outbound: 91000, net: 47000 },
      { name: 'Jun', inbound: 158000, outbound: 101000, net: 57000 },
      { name: 'Jul', inbound: 176000, outbound: 94000,  net: 82000 },
    ],
    expenseBreakdown: [
      { name: 'Cost of Goods',    value: 38200 },
      { name: 'Payroll',          value: 24800 },
      { name: 'Rent & Utilities', value: 12800 },
      { name: 'Marketing',        value: 9400 },
      { name: 'Software',         value: 6200 },
      { name: 'Other',            value: 5140 },
    ],
    topCustomers: [
      { id: 'tc-1', name: 'Nile Trading Co.',  value: 48200, trend: 'up' },
      { id: 'tc-2', name: 'Acme Hardware LLC', value: 36800, trend: 'up' },
      { id: 'tc-3', name: 'Medina Foods',      value: 22400, trend: 'down' },
      { id: 'tc-4', name: 'Delta Wholesale',   value: 18500, trend: 'up' },
      { id: 'tc-5', name: 'Orchid Group',      value: 12400, trend: 'flat' },
    ],
    ratios: {
      currentRatio: 1.84,
      quickRatio:   1.42,
      debtToEquity: 0.58,
      grossMargin:  0.47,
      netMargin:    0.21,
      dso:          38,
      dpo:          31,
    },
    budgetVariance: [
      { id: 'bv-1', category: 'Revenue',     budget: 175000, actual: 184320, variance: 9320,  variancePct: 5.3 },
      { id: 'bv-2', category: 'COGS',        budget: 40000,  actual: 38200,  variance: -1800, variancePct: -4.5 },
      { id: 'bv-3', category: 'Payroll',      budget: 26000,  actual: 24800,  variance: -1200, variancePct: -4.6 },
      { id: 'bv-4', category: 'Marketing',    budget: 8000,   actual: 9400,   variance: 1400,  variancePct: 17.5 },
      { id: 'bv-5', category: 'Operations',   budget: 14000,  actual: 12800,  variance: -1200, variancePct: -8.6 },
    ],
    ebitdaWaterfall: [
      { name: 'Revenue',          value: 184320 },
      { name: 'COGS',             value: -38200 },
      { name: 'Gross Profit',     value: 146120, isTotal: true },
      { name: 'Operating Exp.',   value: -51200 },
      { name: 'EBITDA',           value: 94920,  isTotal: true },
    ],
  },
  watchlistAccounts: [
    { id: 'wa-1', name: 'Operating Account',   code: '1010', nature: 'Debit',  ytd: 184320 },
    { id: 'wa-2', name: 'Accounts Receivable', code: '1200', nature: 'Debit',  ytd: 42180 },
    { id: 'wa-3', name: 'Accounts Payable',   code: '2000', nature: 'Credit', ytd: 28640 },
    { id: 'wa-4', name: 'Inventory',           code: '1300', nature: 'Debit',  ytd: 67800 },
  ],
};
